"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true,
});

exports["default"] = function () {
  var Snap = undefined;
  try {
    Snap = require("snapsvg-cjs");
  } finally {
    return Snap;
  }
};

module.exports = exports["default"];
